import { Button, DeleteButton, Form, Modal, Table, TableCard, Input, Drawer, Export } from 'components'
import React, { useEffect, useState } from 'react'
import { FaPen, FaPlus, FaDownload, FaFilter } from 'react-icons/fa6'

function Guidebook() {
  
  return (
    <TableCard
      header={
        <div className='flex flex-col'>
          <div className='w-full flex justify-between items-center gap-4'>
          <h1 className='text-2xl font-medium'>Guidebook</h1>
            <div className='flex items-center gap-2'>         
              <div className='flex items-center gap-2'>
                <Button 
                  type="default" 
                  // icon={<FaDownload />} 
                  onClick={() => window.open('/files/warehouse-guidebook.pdf', '_blank')}
                >
                  Гарын авлага харах
                </Button>          
                <a href="/files/warehouse-guidebook.pdf" download>
                  <Button type="default" icon={<FaDownload />}>Татах</Button>
                </a>

              </div>
            </div>          
          </div>
        </div>
      }
    >
    </TableCard>
  )
}

export default Guidebook